//クラスに"onClick"がついていたら、data-elmで指定されているelementに"is-on"クラスをつける
let onclicks = document.querySelectorAll(".onClick")

if (document.body.classList.contains("member")) {
    let row = document.querySelector(".member__rowsRow")
    row.classList.add("is-on")
    let li = document.querySelector("ul.btns>li")
    li.classList.add("is-on")

    onclicks.forEach((onclick) => {
        onclick.addEventListener("click", (e) => {

            document.querySelectorAll("ul.btns>li").forEach((e) => {
                e.classList.remove("is-on")
            })

            e.currentTarget.classList.add("is-on")

            document.querySelectorAll(".member__rows>*").forEach((e) => {
                e.classList.remove("is-on")
            })

            let elm = document.querySelector("." + onclick.dataset.elm)
            elm.classList.toggle("is-on")
        })
    })
}

